import { createPinia, PiniaVuePlugin } from 'pinia';
import Vue from 'vue';
import { apolloProvider } from './api/apollo';

Vue.use(PiniaVuePlugin);

export const dsrPublishedVueInstanceOptions = {
  el: '#dsr-published-app',
  render: h =>
    h('div', {
      attrs: {
        id: 'dsr-published-app',
      },
    }),
  pinia: createPinia(),
  apolloProvider,
};
